import styles from '../../assets/styles/Login/Login.module.scss';
import { MimaButton, MimaDropdown, MimaInput } from '../../components';
import { Formik } from 'formik';
import React from 'react';

const SignupForm = ({
	validationSchema,
	onSubmit,
	hasReferral,
	refInputHandler,
	referrerCode,
	loading,
	step,
	stepTwo
}) => {
	const data = ['Webinar/Seminar', 'Instagram', 'Facebook', 'Twitter', 'Google Search', 'Friends & Family', 'Mima Sales Agent', 'Others']

	return (
		<Formik
			initialValues={{
				fullname: '',
				businessname: '',
				businessphonenumber: '',
				businessemail: '',
				password: '',
				businessRegNum: '',
				instagramHandle: '',
				twitterHandle: '',
				website: '',
				referralSource: '',
				referredBy: '',
			}}
			validationSchema={validationSchema()}
			onSubmit={onSubmit}
		>
			{({
				handleChange,
				handleBlur,
				handleSubmit,
				setFieldValue,
				values,
				errors,
				touched,
			}) => (
				<div>
					{(step === 'stepOne') ?
						(<>
							<MimaInput
								labelTitle="Full Name"
								type="text"
								placeholder="Firstname Middlename Lastname"
								id="fullname"
								name="fullname"
								value={values.fullname}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.fullname}
								touched={touched.fullname}
							/>

							<MimaInput
								labelTitle="Business Name"
								type="text"
								className={`${styles.form__input} ${touched.businessname ? styles.filled : null
									}`}
								placeholder="Enter your Business name"
								id="businessname"
								name="businessname"
								value={values.businessname}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.businessname}
								touched={touched.businessname}
							/>

							<MimaInput
								labelTitle="Business Email"
								type="text"
								className={`${styles.form__input} ${touched.businessemail ? styles.filled : null
									}`}
								placeholder="Enter your Business Email"
								id="businessemail"
								name="businessemail"
								value={values.businessemail}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.businessemail}
								touched={touched.businessemail}
							/>

							<MimaInput
								labelTitle="Phone Number"
								type="tel"
								className={`${styles.form__input} ${touched.businessphonenumber ? styles.filled : null
									}`}
								placeholder="Enter your mobile number"
								id="businessphonenumber"
								name="businessphonenumber"
								value={values.businessphonenumber}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.businessphonenumber}
								touched={touched.businessphonenumber}
							/>

							<MimaInput
								labelTitle="Business Registration Number (Optional)"
								type="text"
								className={`${styles.form__input} ${touched.website ? styles.filled : null
									}`}
								placeholder="Enter your business reg. number"
								id="businessRegNum"
								name="businessRegNum"
								value={values.businessRegNum}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.businessRegNum}
								touched={touched.businessRegNum}
							/>

							<MimaButton
								title="Next"
								onClick={stepTwo}
								variant="form"
							/>
						</>) :
						(<>

							<MimaInput
								labelTitle="Website (Optional)"
								type="text"
								className={`${styles.form__input} ${touched.website ? styles.filled : null
									}`}
								placeholder="Enter your website url"
								id="website"
								name="website"
								value={values.website}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.website}
								touched={touched.website}
							/>

							<MimaInput
								labelTitle="Instagram handle (Optional)"
								type="text"
								className={`${styles.form__input} ${touched.instagramHandle ? styles.filled : null
									}`}
								placeholder="Enter your instagram handle"
								id="instagramHandle"
								name="instagramHandle"
								value={values.instagramHandle}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.instagramHandle}
								touched={touched.instagramHandle}
							/>

							<MimaInput
								labelTitle="Twitter handle (Optional)"
								type="text"
								className={`${styles.form__input} ${touched.twitterHandle ? styles.filled : null
									}`}
								placeholder="Enter your twitter handle"
								id="twitterHandle"
								name="twitterHandle"
								value={values.twitterHandle}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.twitterHandle}
								touched={touched.twitterHandle}
							/>

							<MimaDropdown
								labelTitle="How did you hear about mima?"
								placeholder={'Select' && values.referralSource}
								id="referralSource"
								name="referralSource"
								value={values.referralSource}
								currentValue={values.referralSource}
								onChange={data => {
									setFieldValue('referralSource', data.key);
								}}
								data={data.map(item => ({
									key: item,
									value: item
								}))}
								onBlur={handleBlur}
								touched={touched.referralSource}
								error={errors.referralSource}
							/>

							<MimaInput
								labelTitle="Password"
								type="text"
								className={`${styles.form__input} ${touched.fullname ? styles.filled : null
									}`}
								placeholder="Enter your password"
								id="password"
								name="password"
								value={values.password}
								onChange={handleChange}
								onBlur={handleBlur}
								passwordIcon
								error={errors.password}
								touched={touched.password}
							/>

							{hasReferral || referrerCode ? (
								<div className={styles.form__group}>
									<MimaInput
										labelTitle="Referral code"
										type="text"
										className={`${styles.form__input} ${touched.referredBy ? styles.filled : null
											}`}
										placeholder="Enter referral code"
										id="referredBy"
										name="referredBy"
										value={values.referredBy || referrerCode}
										onChange={handleChange}
										onBlur={handleBlur}
										disabled={referrerCode}
									/>
								</div>
							) : (
								<p className={styles.accent} onClick={refInputHandler}>
									Got a referral code?
								</p>
							)}

							<MimaButton
								title="Sign Up"
								type="submit"
								loading={loading}
								onClick={handleSubmit}
								variant="form"
							/>
						</>)
					}
				</div>
			)}
		</Formik>
	);
};

export default SignupForm;
